import clsx from 'clsx'
import React from 'react'
import { padHourTime } from 'lib/utilities'

export function TodayStatus({ active, dayName, opensAt, closesAt, timezone_short }) {
  const colorClassName = active ? 'dome-color-dark-green' : 'dome-color-darkest-grey'
  return (
    <div className="dome-d-flex dome-flex-column dome-align-center dome-gap3">
      <span className="dome-p3 dome-color-med-grey">today is {dayName?.toLowerCase()}:</span>
      {opensAt ? (
        <span
          className={clsx('dome-p2 dome-text-w500', colorClassName)}
        >{`${padHourTime(opensAt)} - ${padHourTime(closesAt)} ${timezone_short}`}</span>
      ) : (
        <span className="dome-p1 dome-color-darkest-grey dome-text-w500">closed</span>
      )}
    </div>
  )
}

export default TodayStatus
